import { useTranslation } from "react-i18next";

const TrustBanner = () => {
  const { t } = useTranslation();

  const stats = [
    { value: "5M+", labelKey: "trust.verifiedFactories", icon: "ri-building-4-line" },
    { value: "180+", labelKey: "trust.countriesServed", icon: "ri-global-line" },
    { value: "72%", labelKey: "trust.dropshippingReady", icon: "ri-truck-line" },
    { value: "50K+", labelKey: "trust.influencerPartners", icon: "ri-star-line" },
  ];

  return (
    <section className="bg-white py-12 border-b border-amber-100">
      <div className="max-w-screen-xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, i) => (
            <div key={i} className="flex flex-col items-center text-center">
              <div className="w-14 h-14 flex items-center justify-center bg-amber-50 rounded-full mb-3">
                <i className={`${stat.icon} text-2xl text-amber-500`}></i>
              </div>
              <div className="text-3xl md:text-4xl font-bold text-amber-600 mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>
                {stat.value}
              </div>
              <div className="text-gray-500 text-sm">{t(stat.labelKey)}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBanner;
